<template>
  <div class="paperlist">
    <van-nav-bar
      :title="'我的试卷'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <div id="canvasPdf"  ></div>

    <van-tabbar v-model="active" active-color="#7d7e80">
      <van-tabbar-item icon="manager" @click="sjshshow">审核</van-tabbar-item>
    </van-tabbar>

    <van-popup v-model="sjshow" style="width: 100%;height: 100%">
      <div style="padding-top: 10px">
        <div style="margin: 0 auto;width:85%;">
          <p>课程：{{ formpaper.kcmc }}</p>
          <p>组卷人：{{ formpaper.zjrname }}</p>
          <p>学年学期：{{ formpaper.xnxq }}</p>
          <p>试卷总分：{{ formpaper.paperValue }}</p>
          <p>考试时长：{{ formpaper.examTime }}</p>
          <p>考试日期：{{ formpaper.examDate }}</p>
          <p>试卷类型：{{ typesFormat(formpaper.types) }}</p>
          <p>试卷数量：{{ formpaper.papernumber }}</p>
          <p>考试方式：{{ formpaper.pcorphone=='1'?'PC端考试':'手机端考试' }}</p>
          <p>PC端开启霸屏：{{ formpaper.isfp=='Y'?'开启':'不开启' }}</p>
          <p>题目乱序：{{ formpaper.istd=='Y'?'乱序':'不乱序' }}</p>
          <p>答案选项乱序：{{ formpaper.isad=='Y'?'乱序':'不乱序' }}</p>
          <p>错题入库：{{ formpaper.iswrong=='Y'?'启用':'不启用' }}</p>
          <p>考生收藏：{{ formpaper.iscollection=='Y'?'启用':'不启用' }}</p>
          <p>启用切屏控制：{{ formpaper.isecsc=='Y'?'开启':'不开启' }}&nbsp;
            {{ formpaper.ecsenum !=null?formpaper.ecsenum+'次系统提醒':'' }}
          </p>
          <p>启用人脸识别：{{ formpaper.isface=='Y'?'开启':'不开启' }}&nbsp;
            {{ formpaper.facetime !=null?formpaper.facetime+'分钟自动本人识别':'' }}
          </p>
        </div>
        <div style="padding-top: 10px;padding-bottom: 10px">
          <van-radio-group v-model="formlc.shzt" direction="horizontal" :disabled="iscz">
            <van-radio name="1">审核通过</van-radio>
            <van-radio name="0">审核不通过</van-radio>
          </van-radio-group>
        </div>
        <div style="padding-left: 10px;padding-top: 10px;padding-bottom: 10px" v-if="formlc.kfzj == '1' ? true : false">
          <van-checkbox v-model="formlc.sfzj" shape="square" :disabled="iscz">终结流程</van-checkbox>
        </div>
        <div style="padding-top: 10px;padding-bottom: 10px">
          <van-field v-model="formlc.shyj" type="textarea" label="" placeholder="审核意见" :disabled="iscz" />
        </div>
        <div style="text-align: center">
          <van-button type="info" size="small" @click="beforeClose" >取 消</van-button>
          <van-button type="info" size="small" @click="sjsh" :disabled="iscz">审 核</van-button>
        </div>
        <div style="height: 20px"> </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import Pdfh5 from "pdfh5";
  import "pdfh5/css/pdfh5.css";
  import {getDicts,selectDictLabel} from "../../utils/data";
  export default {
    data() {
      return {
        pdfh5: null,
        active: 0,
        formview:{
          filetype:null,
          typeid:null,
          filename:null,
          fileurl:null,
        },
        sjshow:false,
        iscz:true,
        formlc:{

        },
        formsh:{

        },
        formpaper:{

        },
        typesOptions:[],
      };
    },
    created() {
      getDicts("paper_type").then(response => {
        this.typesOptions = response.data;
      });
      this.getLiastPaperInfo();
    },
    mounted() {
      this.formview.typeid = this.$route.params.paperId;
      this.formview.filetype = "paper";
      this.formview.filename = "";
      this.formview.fileurl = "";
      let data = {params:this.formview}
      let zhat= this;
      this.$ajax.get("/papersys/papersh/filelistsh",data).then(response => {
        for(var i = 0;i < response.rows.length;i++)
        {
          zhat.formview.filename = response.rows[i].filename;
          zhat.formview.fileurl = response.rows[i].fileurl;
          //实例化
          this.pdfh5 = new Pdfh5("#canvasPdf", {
            pdfurl:  zhat.$global.paperfileapi+response.rows[i].fileurl,//这里就是pdf的路径，可以是本地的，也可以是服务器上的（https://eyepro.com/php_sqlsrv.pdf）
            zoomEnable: true   //控制是否支持缩放的属性，默认为true
          });
          //监听完成事件
          this.pdfh5.on("complete", function (status, msg, time) {
            console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
          })
        }
      });
    },
    methods:{
      onClickLeft() {
        this.$router.push('/sjshindex')
      },
      getLiastPaperInfo(){console.log(this.$route.params)
        this.$ajax.get("/papersys/papersh/"+this.$route.params.paperId).then(res => {
          if (res.code == 200) {
            this.formpaper = res.data;
            this.title = res.data.paperDesc;
            this.paperValue = res.data.paperValue;

          }
        });
        this.$ajax.get("/papersys/papersh/sh/"+this.$route.params.dataid).then(res => {
          if (res.code == 200) {
            this.formlc = res.data;
            if(this.formlc.shzt === '2'){
              this.iscz = false;
            }
          }
        });
      },
      sjshshow(){
        this.sjshow = true;
      },
      beforeClose(){
        this.sjshow = false;
      },
      sjsh() {
        this.$dialog.confirm({
          title: "试卷审核",
          message: "确定要审核吗？",
          messageAlign: 'center'
        }).then(() => {
          if (this.formlc.shzt == '1' || this.formlc.shzt == '0') {
            this.formsh.shzt = this.formlc.shzt;
            this.formsh.shyj = this.formlc.shyj;
            this.formsh.sfzj = this.formlc.sfzj;
            this.$ajax.put('/papersys/papersh/sh', this.formsh).then(response => {
              this.$toast('审核成功')
              this.$router.push({name: 'sjshindex'})
            });
          } else {
            this.$toast('请选择审核状态')
          }
        }).catch(() => {

        })
      },
      typesFormat(value) {
        return selectDictLabel(this.typesOptions, value);
      },
    }
  }
</script>
<style lang="scss" scoped>
  @import "pdfh5/css/pdfh5.css";
  *{
    padding: 0;
    margin: 0;
  }
  html,body,#app {
    width: 100%;
    height: 100%;
  }
  .paperlist{
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/teacherpage/sjshfile.vue